/*
 * @Author: liangen liangen@oppo.com
 * @Date: 2022-05-16 14:10:31
 * @LastEditors: liangen(80398513)
 * @LastEditTime: 2024-06-11 15:22:41
 * @FilePath: /cem-portal-frontend/src/App.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  defineComponent,
  reactive,
  nextTick,
  provide,
  onMounted,
  getCurrentInstance,
  watch
} from '@vue/composition-api'
import moment from 'moment'
import './App.scss'
import { getUserInfo } from './services/personalCenter/personalInfo'
import {
  useDispatch,
  useHistory,
  useRequest,
  useSelector
} from './utils/bhooks'
import { cleanTokenAPI, userLogout } from './services/auth'
import SystemUpgrade from '@/pages/WarningPages/SystemUpgrade'
const App = defineComponent({
  setup() {
    const vm = getCurrentInstance()
    const tran = function (initParam) {
      return vm?.proxy.$t(initParam) as string
    }
    const commit = useDispatch()
    const router = useHistory()
    const state = reactive({
      isRouterAlive: true,
      isLoginError: false,
      isNormal: true
    })

    const { research } = useSelector(({ research }) => ({ research }))
    const { safety } = useSelector(({ safety }) => ({ safety }))
    const reload = () => {
      state.isRouterAlive = false
      nextTick(() => {
        state.isRouterAlive = true
      })
    }

    provide('reload', reload)
    //获取用户信息
    const { state: userInfoData, run: getUserInfoFn } = useRequest(getUserInfo)
    const userInfo = reactive({
      user: '',
      time: moment().format('YYYY-MM-DD HH:mm:ss')
    })

    const dealIndiaCompliance = async (data) => {
      const { isolationCode } = data
      commit('safety/updateState', {
        isolationCode
      })
      const indiaOrgs = ['IP', 'NC', 'OI', 'ORD', 'MK', 'RN']
      const domainMap = {
        'cem-in-osit.wanyol.com': 'https://cem-test.wanyol.com',
        'cem-in.myoas.com': 'https://cem.myoas.com'
      }
      const isManage = sessionStorage.getItem('isManage')
      commit('safety/updateState', {
        isManage: isManage
      })
      // 判断当前是否是印度站点
      if (domainMap[window.location.host]) {
        commit('safety/updateState', {
          isIndia: true
        })
      } else {
        commit('safety/updateState', {
          isIndia: false
        })
      }
      if (!indiaOrgs.includes(isolationCode)) {
        // 表示所属组织属于印度, 印度组织只能登录印度站点
        // 判断登录的域名是否是印度站点域名,非印度组织不能登录印度站点
        if (domainMap[window.location.host]) {
          // 非印度组织登录印度站点
          commit('safety/updateState', {
            isLoginError: true,
            loginErrorTips: tran('common.loginError'),
            redirectUrl: domainMap[window.location.host]
          })
          if (isManage !== '1') {
            setTimeout(async () => {
              // await userLogout({})
              // window.location.href = domainMap[window.location.host]
            }, 5000)
          }
        } else {
          commit('safety/updateState', {
            isLoginError: false,
            loginErrorTips: ''
          })
        }
      } else {
        // 印度组织
        const targetMap = {
          'cem-test.wanyol.com': 'https://cem-in-osit.wanyol.com',
          'cem.myoas.com': 'https://cem-in.myoas.com',
          'cem-sin.oppoit.com': 'https://cem-in.myoas.com'
        }
        if (!domainMap[window.location.host]) {
          commit('safety/updateState', {
            isLoginError: true,
            loginErrorTips: tran('common.loginError2'),
            redirectUrl: targetMap[window.location.host]
          })
          if (isManage !== '1') {
            setTimeout(async () => {
              // await userLogout({})
              // window.location.href = targetMap[window.location.host]
            }, 5000)
          }
        } else {
          commit('safety/updateState', {
            isLoginError: false,
            loginErrorTips: ''
          })
        }
      }
      commit('safety/updateState', {
        isComplete: true
      })
    }

    const initFn = async () => {
      //当正式问卷时需要去掉水印,判断域名即可window?.env.PASSIVE_RESEARCH_DOMAIN
      if (!window?.env.PROD_DOMAIN_LIST?.includes(window.location.origin)) {
        await getUserInfoFn()
        if (userInfoData.data.code == 200) {
          const user = userInfoData?.data?.data || {}
          sessionStorage.setItem('isManage', user.isSysAdmin)
          commit('safety/updateState', {
            isManage: user.isSysAdmin
          })
          Object.assign(userInfo, {
            user: user?.user || ''
          })
          //把用户信息设置到sessionStroage
          sessionStorage.setItem('user', user?.user || '')
          sessionStorage.setItem('userRoleName', user?.roleName || [])

          await dealIndiaCompliance(user)
        }
      }
    }

    watch(
      () => state.isNormal,
      async (val) => {
        if (val) {
          await initFn()
        }
      },
      {
        immediate: true
      }
    )

    onMounted(async () => {
      if (state.isNormal) {
        await initFn()
      }
    })

    const changeIsNormal = (val) => {
      state.isNormal = val
    }

    return () => {
      return (
        <div id="app">
          {!state.isNormal && (
            <SystemUpgrade
              onChangeIsNormal={(val) => changeIsNormal(val)}></SystemUpgrade>
          )}
          {state.isNormal && (
            <transition name="fade-transform" mode="out-in">
              <div style="height: 100%">
                <el-watermark
                  text={userInfo.user ? [userInfo.user, userInfo.time] : []}
                  color={
                    research.addSurvy &&
                    window.location.pathname ===
                      '/v2/front/monitorOverview/createResearch'
                      ? 'transparent'
                      : 'rgba(100, 100, 100, 0.1)'
                  }
                  font='14px "transparent" "PingFang SC","Microsoft YaHei","Roboto","Helvetica","arial","OPPO-R",sans-serif'>
                  <router-view />
                </el-watermark>
              </div>
            </transition>
          )}
        </div>
      )
    }
  }
})

export default App
